import { NavLink } from 'react-router-dom';

export const BankNavigation = () => <nav className="p-box-filters p-bank-nav" aria-label="Secciones de bancos">
    <div className="p-box-filters-items">
        <NavLink to="/banks/tra" className={({isActive})=>isActive?'selected':''}>Resumen y movimientos</NavLink>
        <NavLink to="/banks/acc" className={({isActive})=>isActive?'selected':''}>Cuentas bancarias</NavLink>
        <NavLink to="/banks/reconciliation" className={({isActive})=>isActive?'selected':''}>Conciliación</NavLink>
    </div>
</nav>;
